import { render, staticRenderFns } from "./MiembrosTab.vue?vue&type=template&id=f36e2de6"
import script from "./MiembrosTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MiembrosTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports